import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class EndeksRaporAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "Rapor/GetEndeksRapor";
        super(baseUrl);
    }
    geExportPdfListe(sicilKodu: number, isYadaAboneNo: number) {

        var request = new EndeksRaporRequest(sicilKodu, isYadaAboneNo);
        return this.post("", request, false);
    }
}
export default new EndeksRaporAPI();
class EndeksRaporRequest {
    public sicilKodu: number;
    public isYadaAboneNo: number;

    constructor(sicilKodu: number, isYadaAboneNo: number) {

        this.sicilKodu = sicilKodu;
        this.isYadaAboneNo = isYadaAboneNo;

    }
}
export { EndeksRaporRequest };